import { inject } from '@angular/core';
import { AddressItemApiService } from '@shared/services/address-item-api.service';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const addressItemTableConfig = (): TableConfig => {
  const addressItemApiService = inject(AddressItemApiService);

  return {
    title: 'Quản lý địa chỉ',
    entityName: 'địa chỉ',
    service: addressItemApiService,
    method: 'getAddressItems',
    columns: [
      { field: 'name', header: 'Tên', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'type', header: 'Loại', width: 'min-w-[120px]', sortable: true, type: 'tag', tagType: 'addressType' },
      { field: 'legacy', header: 'Legacy', width: 'min-w-[100px]', sortable: true, type: 'boolean' },
      { field: 'refId', header: 'Ref ID', width: 'min-w-[150px]', sortable: false, type: 'text' }
    ],
    features: {
      // virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};

